module.exports = __webpack_public_path__ + "static/10 -northeastern_university_logo-0a0dda7933e3d66a17a109e723cf74be.png";